import { FC, useEffect } from 'react'
import { Crisp } from 'crisp-sdk-web'
import { useUser } from 'common/services/useUser'
import { useUpdateCrispPeopleProfileMutation } from 'common/services/useCrisp'

const CRISP_WEBSITE_ID = '708c694e-aa84-49e2-8cd3-0fb15d186d01'

const CrispIntegration: FC = () => {
  const { data: user } = useUser({})
  const [updatePeopleProfile] = useUpdateCrispPeopleProfileMutation()

  // Configure Crisp once on mount (browser only)
  useEffect(() => {
    if (typeof window === 'undefined') return

    Crisp.configure(CRISP_WEBSITE_ID)
    Crisp.chat.hide()
  }, [])

  // Apply user data and update people profile whenever user changes
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!user) return

    // Set email if present
    if (user.email) {
      Crisp.user.setEmail(user.email)
    }

    // Update people profile via server-side API to ensure data is persisted
    updatePeopleProfile({}).catch((error) => {
      console.error('Error updating Crisp people profile:', error)
    })
  }, [user, updatePeopleProfile])

  return null
}

export default CrispIntegration
